<template>
    <div class="c2b-container">
        <div class="c2b-router-name-container">
            <p class="c2b-router-name">Relatório de Saldo consolidado</p>
        </div>

        <div class="c2b-content">
            <div class="modal" tabindex="-1" role="dialog" id="c2b-seller-list-balance-filter-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Filtro</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>Data</label>
                                    <v-date-picker 
                                        :input-props="{'class': 'form-control'}" 
                                        popover-visibility="focus"
                                        v-model="sellerBalanceListFilter.balanceDate" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                class="btn btn-primary" 
                                @click="getSellerListWithFilter(sellerBalanceListFilter)"
                                :disabled="loadingFilter">
                                    Filtrar
                                    <Loading v-show="loadingFilter" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="clearFilter()">Restaurar</button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeFilterModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <SellerAccountStatementCmp ref="sellerAccountStatementCmp" />

            <Breadcrumb :items="breadcrumbList" class="mb-3"/>

            <Loading v-if="loading" />

            <div v-show="!loading">
                <div class="mb-3">
                    <button class="btn btn-primary" @click="openFilterModal()">
                        Filtro
                    </button>

                    <json-to-csv
                        class="btn btn-outline-secondary ml-3"
                        :data="sellerBalanceListCsv"
                        name="saldo_consolidado.csv">
                        Exportar para CSV
                    </json-to-csv>
                </div>

                <FilterInformationCmp 
                    v-if="!loading"
                    :filter-submitted="sellerBalanceListFilterSubmitted"
                    :filter-properties="sellerBalanceFilterProperties" />

                <NothingFound v-if="nothingToShow" />

                <div class="table-responsive" v-show="!nothingToShow">
                    <table class="table table-hover table-sm table-striped">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Valor</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(sellerBalance, index) of sellerBalanceList" :key="index">
                                <td>
                                    <p class="mb-0">{{sellerBalance.realName}}</p>
                                    <small class="text-muted">{{sellerBalance.name}}</small>
                                </td>
                                <td>{{sellerBalance.balance | currency}}</td>
                                <td class="text-center c2b-td-with-buttons">
                                    <button type="button" 
                                        class="btn btn-default text-muted" 
                                        data-toggle="dropdown" >
                                        <fa icon="ellipsis-v" v-show="!sellerBalance.loadingListAction"/>
                                        <fa icon="sync-alt" spin v-show="sellerBalance.loadingListAction"/>
                                    </button>

                                    <div class="dropdown-menu">                                        
                                        <span class="dropdown-item"
                                            @click="openAccountStatementListModal(sellerBalance)">Detalhes</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import ModalService from '../../utils/services/ModalService'
import sellerService from '../services/SellerService'
import reportService from '../../report/services/ReportService';
import { SellerBalanceListFilterModel } from '../models/SellerBalanceListFilterModel'
import FilterInformationCmp from '@/utils/components/FilterInformationCmp'
import SellerAccountStatementCmp from '../components/SellerAccountStatementCmp'

const ID_SELLER_LIST_BALANCE_MODAL = '#c2b-seller-list-balance-filter-modal'

export default {
    name: 'SellerBalanceListReportView',
    components: {
        FilterInformationCmp,
        SellerAccountStatementCmp,
    },
    data() {
        return {
            loading: true,
            loadingFilter: false,
            sellerBalanceListFilter: new SellerBalanceListFilterModel(),
            sellerBalanceListFilterSubmitted: new SellerBalanceListFilterModel(),
            sellerBalanceList: [],
            sellerBalanceListCsv: [],            
            breadcrumbList: [
                {
                    id: 1,
                    path: '/vendedores',                    
                    description: 'Vendedores',
                },
                {
                    id: 1,
                    description: 'Relatório de saldo consolidado',
                },
            ],
            sellerBalanceFilterProperties: [
                {
                    type: 'date',
                    label: 'Data',
                    property: 'balanceDate',
                },
            ],
        }
    },
    async mounted() {
        this.loading = true

        this.sellerBalanceListFilterSubmitted = cloneDeep(this.sellerBalanceListFilter)

        try {
            this.sellerBalanceList = await reportService.getSellerBalanceList(this.sellerBalanceListFilterSubmitted)
        } catch (err) {
            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loading = false
    },
    methods: {
        async getSellerListWithFilter(filterForm) {
            this.loadingFilter = true

            this.sellerBalanceListFilterSubmitted = cloneDeep(filterForm)

            try {
                this.sellerBalanceList = await reportService.getSellerBalanceList(this.sellerBalanceListFilterSubmitted)
                this.closeFilterModal()
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.loadingFilter = false
        },
        clearFilter() {
            this.sellerBalanceListFilter = new SellerBalanceListFilterModel()
        },
        openFilterModal() {
            ModalService.show(ID_SELLER_LIST_BALANCE_MODAL)
        },
        closeFilterModal() {
            ModalService.hide(ID_SELLER_LIST_BALANCE_MODAL)
        },
        async openAccountStatementListModal(sellerBalance) {
            sellerBalance.loadingListAction = true

            try {
                const seller = await sellerService.getSellerById(sellerBalance.sellerId)
                await this.$refs.sellerAccountStatementCmp.openAccountStatementListModal(seller)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            sellerBalance.loadingListAction = false
        },
    },
    computed: {
        nothingToShow() {
            return !this.loading && !this.sellerBalanceList.length
        },
    },
    watch: {
        sellerBalanceList(val) {
            this.sellerBalanceListCsv = val.map((s) => {
                return {
                    razao_social: s.realName,
                    fantasia: s.name,
                    valor: s.balance,
                }
            })
        },
    },
}
</script>